<script setup>
import { useAttrs, useListeners } from 'vue';
import { tableRecipe } from './table.recipe';
import { useTableContext } from './useTable';

const { head } = tableRecipe();
const { rootProps } = useTableContext();

const attrs = useAttrs();
const listeners = useListeners();
</script>

<template>
  <th
    data-component="CsTableHead"
    :class="head(rootProps)"
    v-bind="attrs"
    v-on="listeners"
  >
    <slot />
  </th>
</template>
